<template>
  <div class="d-flex justify-content-center mb-3" style="margin-top:100px;">
    <b-spinner label="Loading..."></b-spinner>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>